import { JSX } from 'react'

import { LabelValue, Skeleton } from '~/components/component-library'
import { SponsoredFeeAmount } from '~/components/txn-display/cost-display/SponsoredFeeAmount'

type CostDisplayBaseProps = {
  isLoading: boolean
  isSponsored: boolean
  cost: number
}

type CostDisplayCollapsibleProps =
  | {
      isCollapsible: true
      defaultOpen?: boolean
      children: JSX.Element
    }
  | {
      isCollapsible?: false
      defaultOpen?: never
      children?: never
    }

type CostDisplayProps = CostDisplayBaseProps & CostDisplayCollapsibleProps

export const CostDisplay = ({
  isLoading,
  isSponsored,
  cost,
  isCollapsible,
  defaultOpen,
  children,
}: CostDisplayProps) => {
  const props = {
    label: 'Gas fees',
    size: 'small' as const,
    value: (
      <div className="flex items-center gap-2 text-sm">
        {isLoading ? (
          <Skeleton length={2} height={1} />
        ) : (
          <SponsoredFeeAmount cost={cost} isSponsored={isSponsored} />
        )}
      </div>
    ),
  }

  if (isCollapsible) {
    return (
      <LabelValue {...props} isCollapsible defaultOpen={defaultOpen}>
        {children}
      </LabelValue>
    )
  }

  return <LabelValue {...props} />
}
